// extracted by mini-css-extract-plugin
export var button = "transition-team-slider-module--button--386c6";
export var container = "transition-team-slider-module--container--ba691";
export var next = "transition-team-slider-module--next--d82f1";
export var prev = "transition-team-slider-module--prev--9735f";
export var slider = "transition-team-slider-module--slider--e7bf4";
export var sliderGrid = "transition-team-slider-module--slider-grid--2983f";
export var title = "transition-team-slider-module--title--f3a42";